import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Button, ButtonGroup, FormControlLabel, Grid } from "@mui/material";
import EditFormControl from "components/form/EditFormControl";
import { ERR_NETWORK } from "constants/messages";
import {
  getCurrentWeekNum,
  getCurrentYearNum,
  getDayName,
  getWeekDaysByWeekNumber,
  weekCount,
} from "lib/date";
import { getPies } from "models/piesModel";
import { getAllRegions } from "models/regionModel";
import { getBakesDates } from "models/weeklySlotsModel";
import { useSnackbar } from "notistack";
import BoxesSummary from "pages/boxes/BoxesSummary";
import DailySummary from "pages/weekly-slots/daily-information/DailySummary";
import DailySummaryTable from "pages/weekly-slots/daily-information/DailySummaryTable";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
// import DailySummary from "./daily-information/DailySummary";

export default function BakeDatesComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [pies, setPies] = useState([]);
  const [regions, setRegions] = useState([]);
  const [weeklySlots, setWeeklySlots] = useState([]);
  const [selWeekType, setSelWeekType] = useState("cur");
  const [selWeekNum, setSelWeekNum] = useState(getCurrentWeekNum());
  const [weeks, setWeeks] = useState([]);
  const [selWeek, setSelWeek] = useState({});
  const [selYear, setSelYear] = useState({
    id: getCurrentYearNum(),
    label: getCurrentYearNum().toString(),
  });

  const handleChangeWeek = (v) => {
    let type = v;
    if (v === "cur")
      setSelWeekNum(() => {
        setSelWeek(weeks?.[getCurrentWeekNum() - 1] ?? {});
        return getCurrentWeekNum();
      });
    if (v === "prev") {
      if (selWeekNum === 1) return;
      setSelWeekNum((prev) => {
        type =
          prev - 1 > getCurrentWeekNum()
            ? "next"
            : prev - 1 === getCurrentWeekNum()
            ? "cur"
            : v;
        const weekNum = prev - 1;
        setSelWeek(weeks?.[weekNum - 1] ?? {});
        return weekNum;
      });
    }
    if (v === "next") {
      if (selWeekNum === weekCount) return;
      setSelWeekNum((prev) => {
        type =
          prev + 1 < getCurrentWeekNum()
            ? "prev"
            : prev + 1 === getCurrentWeekNum()
            ? "cur"
            : v;
        const weekNum = prev + 1;
        setSelWeek(weeks?.[weekNum - 1] ?? {});
        return weekNum;
      });
    }
    setSelWeekType((prev) => type);
  };
  const handleChangeWeekNum = (e) => {
    const weekNum = e.target.value?.id ?? 1;
    setSelWeekNum((prev) => {
      setSelWeekType((prev) =>
        (weekNum ?? 0) > getCurrentWeekNum()
          ? "next"
          : weekNum === getCurrentWeekNum()
          ? "cur"
          : "prev"
      );
      return weekNum ?? 1;
    });
    setSelWeek(e.target.value);
  };

  const loadData = () => {
    openLoading(true);
    getBakesDates({
      data: {
        week_num: selWeekNum,
        week_year: selYear?.id ?? getCurrentYearNum(),
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        const orders = res.map((order) => {
          const reg = regions?.filter(
            (item, index, self) => item?.postcode === order?.address?.postcode
          );
          return {
            ...order,
            region: reg?.[0]?.region,
          };
        });
        setWeeklySlots(orders);
      },
    });
  };

  const loadPies = () => {
    getAllRegions({
      onFinish: (res, err) => {
        setRegions(res);
        getPies({
          onFinish: (res, err) => {
            if (res === false) {
              if (!res && err?.message) {
                enqueueSnackbar(err?.message, { variant: "warning" });
              } else {
                enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
              }
              return;
            }
            setPies(res);
          },
        });
      },
    });
  };

  const setCurrentYearWeeks = () => {
    const weeklyInfos = Array.from(Array(weekCount).keys()).reduce(
      (ret, cur, index) => {
        const label = `Week ${cur + 1} (${getWeekDaysByWeekNumber({
          weekNumber: cur + 1,
          addDay: 0,
          format: "DD MMM",
          yearNumber: selYear?.id,
        })} ~ ${getWeekDaysByWeekNumber({
          weekNumber: cur + 1,
          addDay: 6,
          format: "DD MMM",
          yearNumber: selYear?.id,
        })})`;
        return [...ret, { id: cur + 1, label: label }];
      },
      []
    );
    setSelWeek(() => weeklyInfos[selWeekNum - 1]);
    setWeeks(() => weeklyInfos);
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selWeekNum, selYear, regions]);

  useEffect(() => {
    setCurrentYearWeeks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selYear]);

  useEffect(() => {
    loadPies();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="my-2">
      <Grid
        container
        spacing={4}
        className="mb-1.5"
        justifyContent="space-between"
      >
        <Grid item>
          <ButtonGroup>
            <Button
              className={`${
                selWeekType === "prev" ? "bg-white-gray" : "bg-white"
              } ${selWeek === 1 ? "cursor-not-allowed" : "cursor-pointer"}`}
              color="secondary"
              key="prev"
              onClick={() => handleChangeWeek("prev")}
              startIcon={<KeyboardArrowLeftIcon />}
            >
              {`Previous Week ${
                selWeekType === "prev" ? `(${selWeekNum})` : ""
              }`}
            </Button>
            <Button
              className={`${
                selWeekType === "cur" ? "bg-white-gray" : "bg-white"
              }`}
              color="secondary"
              key="cur"
              onClick={() => handleChangeWeek("cur")}
            >
              {`This Week (${getCurrentWeekNum()})`}
            </Button>
            <Button
              className={`${
                selWeekType === "next" ? "bg-white-gray" : "bg-white"
              } ${
                selWeek === weekCount ? "cursor-not-allowed" : "cursor-pointer"
              }`}
              color="secondary"
              key="next"
              endIcon={<ChevronRightIcon />}
              onClick={() => handleChangeWeek("next")}
            >
              {`Next Week ${selWeekType === "next" ? `(${selWeekNum})` : ""}`}
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid item>
          <div className="flex">
            <div className="ml-2">
              <FormControlLabel
                className="mr-2"
                label="Year: "
                labelPlacement="start"
                control={
                  <div className="ml-2">
                    <EditFormControl
                      type="select"
                      options={Array.from(Array(4).keys()).reduce(
                        (ret, cur) => [
                          ...ret,
                          {
                            id: getCurrentYearNum() - cur,
                            label: (getCurrentYearNum() - cur).toString(),
                          },
                        ],
                        [
                          {
                            id: getCurrentYearNum() + 1,
                            label: (getCurrentYearNum() + 1).toString(),
                          },
                        ]
                      )}
                      optionLabel={(option) => option.label}
                      name="selWeek"
                      size="small"
                      onChange={(e) => setSelYear(e.target.value)}
                      data={{ selWeek: selYear }}
                    />
                  </div>
                }
              />
            </div>
            <div>
              <FormControlLabel
                className="m-0"
                label="Week: "
                labelPlacement="start"
                control={
                  <div className="ml-2">
                    <EditFormControl
                      type="select"
                      className="w-60"
                      options={weeks}
                      optionLabel={(option) => option.label}
                      name="selWeek"
                      size="small"
                      onChange={handleChangeWeekNum}
                      data={{ selWeek: selWeek }}
                    />
                  </div>
                }
              />
            </div>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <BoxesSummary
            data={weeklySlots}
            summary={{ title: "Weekly Breakdown", boxes: "78", pies: "624" }}
            progress={{ title: "week Slot Availability", value: 19 }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <DailySummaryTable
            data={weeklySlots}
            selWeekNum={selWeekNum}
            pies={pies}
            type="bake-date"
            exportType="week"
            dateType={`${selWeekNum} week`}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          {Array.from(Array(5).keys()).map((key) => {
            const dayData = weeklySlots?.filter((item) =>
              key === 4 ? item?.week_day === 1 : item.week_day === key + 2
            );
            const weekDay = getWeekDaysByWeekNumber({
              weekNumber: selWeekNum,
              addDay: dayData?.[0]?.week_day === 1 ? 4 : key,
              format: "DD, MMMM",
              yearNumber: selYear?.id ?? getCurrentYearNum(),
            });
            return (
              <DailySummary
                key={key}
                weekDay={weekDay}
                pies={pies}
                data={dayData}
                selWeekNum={selWeekNum}
                type="bake-date"
                onRefresh={loadData}
                dayName={getDayName(key + 1)}
              />
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
}
